import React, { useEffect, useState} from 'react'
import axios from 'axios';
import Swal from "sweetalert2";
import { FaEdit, FaTimes } from "react-icons/fa";
import { AiOutlineInfoCircle } from 'react-icons/ai';
import './capacidades_style.css'
import AWS from "aws-sdk";

function Capacidades() {
  const [users, setUsers] = useState([])
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const [loading, setLoading] = useState(true)
  const [searchValue, setSearchValue] = useState("");
  //***************Prod
  const config = {
      bucketName: "amx-reports-tcfdi-us-east-1-390403873189-pd", // Replace with your S3 bucket name
      region: "us-east-1", // Replace with your region        
  };
  // const getTempCredentials = async () => {
  //     try {
  //         const response = await fetch("https://tcfdi-serv.amsrvc.com/tcfdi/api/v1/capacities/getTempCredentials"); // API Gateway URL
  //         const data = await response.json();
  //         return data;
  //     } catch (error) {
  //         console.error('Error fetching credentials:', error);
  //     }
  // };
  //*****************DEV
  // const config = {
  //     bucketName: "amx-reports-tcfdi-us-east-1-307946642639-de", // Replace with your S3 bucket name
  //     region: "us-east-1", // Replace with your region        
  // };
  const getTempCredentials = async (file) => {
    try {
      if (!file) {
        console.error('No se ha seleccionado ningún archivo.');
        return;
      }

      const allowedMimeTypes = [
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ];
      if (!allowedMimeTypes.includes(file.type)) {
        console.error('Formato de archivo no válido. Solo se permiten archivos Excel (.xls y .xlsx).');
        return;
      }

      // ✅ Este es el cambio clave: crea un objeto JSON, no un FormData.
      const body = {
        fileName: file.name,
        contentType: file.type,
      };

      const response = await fetch(`${process.env.REACT_APP_URL_BACKEND}/capacities/getTempCredentials2`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', // Le dice al servidor que es JSON
        },
        body: JSON.stringify(body), // Convierte el objeto a una cadena JSON
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error en la solicitud para obtener credenciales.');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching credentials:', error);
      throw error;
    }
  };
  
  const getUsers = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/capacities`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
        },
      });
      if (res.data.code === 1){
        setUsers(res.data.users)
        setLoading(false)
      }
      
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
      setLoading(true)
    }
  };
  
  const deleteUser = async ( id ) => {
    try {
      const result = await Swal.fire({
        title: "¿Estás seguro?",
        text: "¡No podrás revertir esto!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminarlo",
        cancelButtonText: "No, cancelar",
        reverseButtons: true,
        buttonsStyling: true,
      });

      if (result.isConfirmed) {
        await axios.delete(
          `${process.env.REACT_APP_URL_BACKEND}/capacities/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
            },
          }
        );

        Swal.fire("¡Eliminado!", "Capacidades eliminads.", "success");
        setUpdateTrigger(!updateTrigger);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          "Cancelado",
          "error"
        );
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
    }
  }
  
  const updateUser = async (id) => {
    try {
      // Obtener los datos del usuario a editar del servidor
      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/capacities/${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
          },
        }
      );
      const userData = response.data.user;

      const result = await Swal.fire({
        title: "Editar Capacidades",
        html:
          '<div class="form-grid">' +
          `<input type="text" id="name" class="swal2-input" placeholder="Pepito Perez" value="${userData.name}">` +
          `<input type="hidden" id="id" class="swal2-input" placeholder="Pepito Perez" value="${userData.id}">` +
          "</div>",
        showCancelButton: true,
        confirmButtonText: "Actualizar",
        cancelButtonText: "Cancelar",
        preConfirm: function () {
          return new Promise(function (resolve) {
            resolve({
              name: document.getElementById("name").value,
              id: document.getElementById("id").value,
            });
          });
        },
      });

      if (result.isConfirmed) {
        const updatedUserData = result.value;
        // Realizar la solicitud PUT al servidor para actualizar el usuario
        const updateResponse = await axios.put(
          `${process.env.REACT_APP_URL_BACKEND}/capacities/update`,
          updatedUserData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
            },
          }
        );
        Swal.fire(
          "¡Actualizado!",
          "Capacidades actualizadas.",
          "success"
        );
        setUpdateTrigger(!updateTrigger);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          "Cancelado",
          "No se ha realizado ninguna actualización.",
          "error"
        );
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
    }
  };
  
  const createUser = async () => {
    try {
      const result = await Swal.fire({
        title: "Agregar capacidades",
        html:
          '<div class="form-grid">' +
          '<input type="file" id="file" class="swal2-input" placeholder="Archivo de capacidades">' +
          '<input type="hidden" id="id_user" value="2">' +
          "</div>",
        showCancelButton: true,
        confirmButtonText: "Crear",
        cancelButtonText: "Cancelar",
        preConfirm: function () {
          return new Promise(function (resolve) {
            resolve({
              file: document.getElementById("file").files[0],
              id_user: document.getElementById("id_user").value,
            });
          });
        },
      });

      if (result.isConfirmed) {
        const file = document.getElementById("file").files[0];
        if (!file) {
          return;
        }
        
        // La clave es que todo el flujo de subida y APIs esté en el mismo try
        const urls = await getTempCredentials(file);
        const { uploadUrl, fileUrl } = urls;
        console.log(uploadUrl);
        console.log(file.type);
        const uploadResponse = await fetch(uploadUrl, {
            method: 'PUT',
            body: file,
            headers: {
                'Content-Type': file.type,
                'x-amz-acl': 'private'
            },
        });

        console.log(uploadResponse);
        // 4. Manejar la respuesta de la subida
        if (uploadResponse.ok) {
            console.log("✅ Archivo subido con éxito.");
            console.log("URL del archivo:", fileUrl);
            const apiResponse = await axios.post(
              `${process.env.REACT_APP_URL_BACKEND}/capacities/create`,
              {
                fileUrl: fileUrl,
                id_user: localStorage.getItem('user_naem'),
                which: 'capacities',
              },
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                  "Content-Type": "application/json",
                },
              }
            );

            // Si llegamos aquí, todas las llamadas fueron exitosas
            Swal.fire("¡Carga correcta!", "El archivo se esta procesando.", "success");
            setUpdateTrigger(!updateTrigger);
        } else {
            // Manejar errores de la subida a S3
            console.error("❌ Error al subir el archivo:", uploadResponse.statusText);
            Swal.fire("Error", "Ha ocurrido un error inesperado.", "error");
        }
        
        
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelado", "Accion cancelada.", "error");
      }
    } catch (error) {
      console.error('El objeto de error completo es:', error);
      // Todos los errores (de APIs, de S3, etc.) serán capturados aquí
      // Ahora puedes usar los mensajes del error para mostrar la alerta correcta
      if (error.response && error.response.data && error.response.data.message) {
        if (error.response.data.message === "Fechas de capacidades existentes") {
          Swal.fire("Error al agregar capacidades", "Las fechas ya existen.", "error");
        } else if (error.response.data.message === "Capacidades borradas anteriormente") {
          Swal.fire("Error al agregar capacidades", "Capacidades borradas anteriormente", "error");
        } else if (error.response.data.message === "El formato de capacidades no es valido") {
          Swal.fire("Error al agregar capacidades", "El formato de capacidades no es valido", "error");
        } else {
          // Para cualquier otro error de respuesta de la API
          Swal.fire("Error al agregar capacidades", error.response.data.message, "error");
        }
      } else {
        // Para errores de red, S3, o cualquier otro tipo de error
        console.error(error);
        Swal.fire("Error", "Ha ocurrido un error inesperado.", "error");
      }
    }
  };

  const deleteCapacidades = async () => {
    try {
      const result = await Swal.fire({
        title: "Eliminar capacidades",
        html:
          '<div class="row">' +
          '<div class="col-12">' +
          '<br/><label className="mt-3">Fecha Inicio</label><br/>'+
          '<input type="date" id="start_date" class="form-control" placeholder="País">' +
          '<br/><label className="mt-3">Fecha Fecha Fin</label><br/>'+
          '<input type="date" id="end_date" class="form-control" placeholder="País">' +
          '</div>'+
          "</div>",
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
        preConfirm: function () {
          return new Promise(function (resolve) {
            resolve({
              start_date: document.getElementById("start_date").value,
              end_date: document.getElementById("end_date").value,
              which: 'delete_capacities',
              user: localStorage.getItem('user_naem')
            });
          });
        },
      });
  
      if (result.isConfirmed) {
        const userData = result.value;
  
        const response = await axios.post(
          `${process.env.REACT_APP_URL_BACKEND}/capacities/destroy`,
          userData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        Swal.fire(
          "¡Eliminando!",
          "La información de capacidades se esta eliminando.",
          "success"
        );
        setUpdateTrigger(!updateTrigger);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelado", "Accion cancelada.", "error");
      }
    } catch (error) {
      if (error.response.data.message === "Fechas de capacidades existentes") {
        Swal.fire("Error al agregar capacidades", "Las fechas ya existen.", "error");
      } else if (error.response.data.message === "Capacidades borradas anteriormente") {
        Swal.fire("Error al agregar capacidades", "Capacidades borradas anteriormente", "error");
      }else if (error.response.data.errors[0] === "El formato de capacidades no es valido") {
        Swal.fire("Error al agregar capacidades", "El formato de capacidades no es valido", "error");
      } else {
        Swal.fire(
          "Error al agregar capacidades",
          "No se ha creado ningún país."
        );
      }
    }
  };
  
  const handleSearch = () => {
    const input = document.getElementById("searchInput");
    setSearchValue(input.value.trim());
  };
  
  const filteredUsers = searchValue
  ? users.filter(
      (user) =>
        user.name
          .toUpperCase()
          .includes(searchValue.toUpperCase()) ||
        user.email.toUpperCase().includes(searchValue.toUpperCase())
    )
  : users

  useEffect(() => {
    getUsers();
  }, [updateTrigger]);

  const getStatusClass = (status) => {
      if (status == 1) {
          return 'ready';
      } else if (status == 0) {
          return 'pending';
      } else if (status == 2) {
          return 'error';
      }
      return 'Nullo'; // Retorna una cadena vacía si el estado no coincide
  };

  const handleShowErrorSwal = (user) => {
      Swal.fire({
        title: `Error en la subida de: ${user.name}`,
        icon: 'error',
        width: '80%',
        html: `
          <h4>Información detallada del error:</h4>
          <p>${user.status_info}</p>
        `,
        showConfirmButton: true,
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#dc3545'
      });
    };

  return (
    <>
    <div className="panel-table">
    <div className='colum-left'>
      <input type="text" className='searchInput' id="searchInput" placeholder="Buscar..." />
      <button className='btnn' onClick={handleSearch}>Buscar</button>
    </div>
    <div className='colum-rigth'>
      <button className="btnn" onClick={createUser}>
        Agregar capacidades
      </button>
      <button className="btnn" onClick={deleteCapacidades}>
        Eliminar capacidades
      </button>
    </div>
    </div>
    <div className='table-responsive'>
      <table className='table table-preve' id='tableToSearch'>
        <thead>
          <tr>
            <th>Nombre Archivo</th>
            <th>Usuario</th>
            <td>Fecha</td>
            <th>Estatus</th>
            <th>Mensaje Estatus</th>
          </tr>
        </thead>
        
        <tbody>
        {loading ? (
          <tr><td>Cargando...</td></tr>
        ) : (
          [...filteredUsers].reverse().map((user) => (
            <tr>
              <td>
                {user.name}
              </td>
              <td>{user.user_id}</td>
              <td>
                {new Date(user.created_at).toLocaleString('es-ES', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit'
                })}
              </td>
              <td className="">
                <span className={`dot ${getStatusClass(user.status)}`}></span>
                {user.status == 2 && (
                  "Error"
                )}
                {user.status == 1 && (
                  "Completo"
                )}
                {user.status == 0 && (
                  "Procesando"
                )}
              </td>
              <td className="text-center">
                {user.status == 2 && (
                  <button 
                    className="info-button"
                    onClick={() => handleShowErrorSwal(user)}
                  >
                     <AiOutlineInfoCircle />
                  </button>
                )}
              </td>
            </tr>
          ))
        )}

        </tbody>
      </table>
    </div>
    </>
  )
}

export default Capacidades